module.exports = __webpack_public_path__ + "fonts/sourcesanspro-regular-webfont.0fbca719.woff2";